export default "__VITE_ASSET__CGxs6ftV__"